module.exports = __webpack_public_path__ + "img/5-5.118f2760.svg";